module.exports = __webpack_public_path__ + "img/chair_cool_on.f7bf7f52.png";